import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { safObjectHelper } from '../../../../../utils/SafObjectHelper.ts';
import { companyApi } from '../../../../../modules';

interface IProps {
  ref?: any;
  formCode?: string;
  section?: any;
  data: any;
}

const View = (props: IProps) => {
  const [companyName, setCompanyName] = useState<any>();
  useEffect(() => {
    if (!props.data?.companyId) return;
    companyApi.getCompanyDetail({ companyId: props.data.companyId }).then((res) => {
      setCompanyName(res.resultObject.companyName);
    });
  }, [props.data?.companyId]);
  return (
    <div className={'preview-bottom-border'}>
      <div className={'preview-row'}>
        <div
          className={'preview-col preview-label saf-bg-white'}
          style={{ color: 'red', fontSize: '0.5em' }}
        >
          &nbsp;
        </div>
      </div>
      <table className={'preview-table preview-white-table  preview-top-border'}>
        <colgroup>
          <col width={'25%'} />
          <col width={'75%'} />
        </colgroup>
        <tbody>
          <tr>
            <th style={{ height: '2.1rem', alignContent: 'center' }}>Crane Setup Area</th>
            <th>
              <div className={'preview-row-02'}>
                <div style={{ alignContent: 'center' }}>Concrete</div>
                <div>
                  <input type={'checkbox'} />
                </div>
                <div style={{ alignContent: 'center' }}>Gravel</div>
                <div>
                  <input type={'checkbox'} />
                </div>
                <div style={{ alignContent: 'center' }}>Soil</div>
                <div>
                  <input type={'checkbox'} />
                </div>
              </div>
            </th>
          </tr>
          <tr>
            <th style={{ height: '2.1rem', alignContent: 'center' }}>Others (Specify)</th>
            <th></th>
          </tr>
          <tr>
            <th style={{ height: '2.1rem', alignContent: 'center' }}>Wind Speed Limit (m/s)</th>
            <th></th>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
